import { ROUTES } from "routing/routes";

import { linkToEditClassAssignment } from "features/teachers/routes/teacher/routes/class/routes/edit-assignment/links";

import {
  linkToEditAssignmentInviteParentsPage,
  linkToEditAssignmentJourneyDetailsPage,
  linkToEditAssignmentJourneyExamQuestions
} from "./links";

export const CREATE_ASSIGNMENT_FORM_NAME = "create-assignment";
export const TIME_PICKER_INTERVAL = 15; // mins

export enum FlowMode {
  create = "create",
  edit = "edit"
}

export enum AssignmentSpecType {
  courseSections = "course-sections",
  courseUserSections = "course-user-sections",
  courseExamQuestions = "course-exam-questions"
}

export enum AssignmentSteps {
  selectClass = "Class",
  selectType = "Type",
  selectTopics = "Topics",
  examQuestions = "Exam Questions",
  addDetails = "Details",
  inviteParents = "Parents"
}

export enum NextButtonMode {
  next = "next",
  skip = "skip",
  create = "create",
  final = "final",
  addCourses = "add-courses",
  selectClasses = "select-classes"
}

export type AssignmentFlowStep = {
  link: (classId?: string, assignmentId?: string) => string;
  description: AssignmentSteps;
};

export const AssignmentCreateFlowSteps: AssignmentFlowStep[] = [
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.CLASS.buildPath({}),
    description: AssignmentSteps.selectClass
  },
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.TYPE.buildPath({}),
    description: AssignmentSteps.selectType
  },
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.TOPICS.buildPath({}),
    description: AssignmentSteps.selectTopics
  },
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.EXAM_QUESTIONS.buildPath({}),
    description: AssignmentSteps.examQuestions
  },
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.DETAILS.buildPath({}),
    description: AssignmentSteps.addDetails
  },
  {
    link: () => ROUTES.TEACHER.ASSIGNMENTS.CREATE.INVITE_PARENTS.buildPath({}),
    description: AssignmentSteps.inviteParents
  }
];

export const AssignmentEditFlowSteps: AssignmentFlowStep[] = [
  {
    link: linkToEditClassAssignment,
    description: AssignmentSteps.selectTopics
  },
  {
    link: linkToEditAssignmentJourneyExamQuestions,
    description: AssignmentSteps.examQuestions
  },
  {
    link: linkToEditAssignmentJourneyDetailsPage,
    description: AssignmentSteps.addDetails
  },
  {
    link: linkToEditAssignmentInviteParentsPage,
    description: AssignmentSteps.inviteParents
  }
];

export enum CreateAssignmentSource {
  classOverview = "class-overview",
  classesPage = "classes-page",
  assignmentsOverview = "assignments-overview",
  gradebook = "gradebook",
  home = "home",
  teacherAssignments = "teacher-assignments"
}

export const ASSIGNMENT_TITLE_LIMIT = 80;
